import styled from "styled-components";

export const BackBtn = styled.span`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #000;
    ${p => p.arrow && `
        &::before{
            display: inline-flex;
            content: "";
            border: solid #3b425e;
            border-width: 0 2px 2px 0;
            padding: 2px;
            margin-right: 5px;
            transform: rotate(135deg);
        }
    `}
`;